import { DDSTypography } from 'den-design-system'
import React from 'react'
import pallete from '../../global/newPallete'

interface SFVerticalBasicDetailsCardProps {
  title?: string
  permissionSetNameTitle: string
  permissionSetNameData?: string
  descriptionTitle: string
  descriptionData?: string
  activationRequiredTitle: string
  activationRequiredData?: string
  createdByTitle: string
  createdByData?: string
  createdOnTitle: string
  createdOnData?: string
  modifiedByTitle: string
  modifiedByData?: string
  modifiedOnTitle: string
  modifiedOnData?: string
}

const SFVerticalBasicDetailsCard: React.FC<SFVerticalBasicDetailsCardProps> = ({
  permissionSetNameTitle,
  permissionSetNameData,
  descriptionTitle,
  descriptionData,
  activationRequiredTitle,
  activationRequiredData,
  createdByTitle,
  createdByData,
  createdOnTitle,
  createdOnData,
  modifiedByTitle,
  modifiedByData,
  modifiedOnTitle,
  modifiedOnData
}) => {
  const DetailRow = ({
    label,
    value
  }: {
    label: string
    value?: string | number
  }) => (
    <div className='px-[16px] py-[16px] border-b border-gray-200 last:border-b-0'>
      <DDSTypography.Paragraph
        size='para'
        variant='semiBold'
        color={pallete.colors.textDark5}
        className='mb-[8px]'
      >
        {label}
      </DDSTypography.Paragraph>
      <DDSTypography.Title
        type='h5'
        variant='semiBold'
        color={pallete.colors.textDark3}
      >
        {value || value === 0 ? value : '-'}
      </DDSTypography.Title>
    </div>
  )

  return (
    <div className='max-w-md bg-white rounded-lg border border-gray-200 shadow-sm'>
      <div className='divide-y divide-gray-200'>
        <DetailRow
          label={permissionSetNameTitle}
          value={permissionSetNameData}
        />
        <DetailRow
          label={activationRequiredTitle}
          value={activationRequiredData}
        />
        <DetailRow label={modifiedOnTitle} value={modifiedOnData} />
        <DetailRow label={modifiedByTitle} value={modifiedByData} />
        <DetailRow label={createdOnTitle} value={createdOnData} />
        <DetailRow label={createdByTitle} value={createdByData} />
        <DetailRow label={descriptionTitle} value={descriptionData} />
      </div>
    </div>
  )
}

export default SFVerticalBasicDetailsCard
